const validEmailRegex = /.+@.+\..+/;

export const isValidEmail = (email?: string): boolean => {
  return typeof email === 'string' && validEmailRegex.test(email.trim());
};
